<template>
  <div class="photo-item">
    <img :src="photoSrc" class="photo-blur" />
    <img :src="photoSrc" class="photo-original" />
    <!-- download photo -->
    <div class="share-buttons">
      <div
        v-if="certificateEnabled"
        class="download-btn button-certificate"
        :class="{ 'is-disabled': purchaseStatus === 'no_order_found' }"
        @click="downloadCertificate"
      >
        <v-progress-circular
          v-if="isLoading"
          indeterminate
          size="20"
          width="2"
          color="#000000"
        />
        <img v-else src="@/assets/result_cert.svg" alt="cert" />
      </div>
      <div
        class="download-btn button-download"
        v-if="canDownload"
        @click="downloadPhoto(downloadLink)"
      >
        <img src="@/assets/result_download.svg" alt="download" />
      </div>
    </div>
  </div>
</template>
<script>
import { usePhoto } from "./usePhoto.js";

export default {
  props: {
    photo: Object,
    resultId: [String, Number],
    canDownload: Boolean,
    purchaseStatus: String,
    certificateEnabled: Boolean,
  },
  setup(props, { emit }) {
    return usePhoto(props, emit);
  },
};
</script>
<style lang="scss" scoped>
.photo-item {
  display: flex;
  position: relative;
  max-width: 308px;
  border-radius: 4px;
  height: 462px;
  overflow: hidden;
  .photo-blur {
    opacity: 0.666;
  }
  .share-buttons {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    // padding-top: 28px;
    // padding-right: 28px;
    padding-top: 20px;
    padding-right: 18px;
    .download-btn {
      height: 37px;
      width: 37px;
      border-radius: 19px;
      margin-left: 12px;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      // position: relative;
      @include cursorPointer;
    }
    .download-btn {
      color: #000000;
      background-color: rgba(255, 255, 255, 1);
      opacity: 1;
      transition: all 200ms ease-out;
    }
    .download-btn:hover {
      opacity: 0.6;
      // background-color: rgba(255, 255, 255, 0.3);
    }
    .is-disabled {
      opacity: 0.4;
    }
  }
}
.photo-blur {
  height: 100%;
  width: 100%;
  // flex-grow: 1;
  object-fit: cover;
  filter: blur(15px);
}
.photo-original {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translate(0, -50%);
  flex-grow: 1;
}
</style>